export class WhatsAppUnreadMessageView {


    customerId: number;
    customerName: string;
    customerLastName: string;
    lastMessageContent: string;
    lastMessageDate: Date;
    whatsappId: string;
    lastPartnerRfpId: number;

    constructor(data: Partial<WhatsAppUnreadMessageView>) {
        this.customerId = data.customerId ?? 0;
        this.customerName = data.customerName ?? '';
        this.customerLastName = data.customerLastName ?? '';
        this.lastMessageContent = data.lastMessageContent ?? '';
        this.lastMessageDate = data.lastMessageDate ?? new Date();
        this.whatsappId = data.whatsappId ?? '';
        this.lastPartnerRfpId = data.lastPartnerRfpId ?? 0;
    }
}
